import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainStatusBadgeWrapper: {
        position: "relative",
        boxSizing: "content-box !important" as "content-box",
        overflow: "hidden",
    },
    pie: {
        width: theme.spacing(4.5),
        aspectRatio: 1,
        display: "inline-grid",
        placeContent: "center",
        margin: theme.spacing(1.25),
        fontSize: 25,
        fontWeight: "bold",
        fontFamily: "sans-serif",
        position: "relative",
        borderRadius: "50%",
    },
    pieBefore: {
        content: "''",
        position: "absolute",
        borderRadius: "50%",
        inset: 0,
    },
}));
